<script>
import { Pivot } from '@click2buy/vue-pivot-table'
export default {
  extends: Pivot,
  mounted: function () {
    this.showSettings = this.defaultShowSettings
  }
}
</script>
